__turbopack_context__.v({
  "heading": "InclusionHoverTip-module__dSauMW__heading",
  "label": "InclusionHoverTip-module__dSauMW__label",
  "tip": "InclusionHoverTip-module__dSauMW__tip",
  "wrap": "InclusionHoverTip-module__dSauMW__wrap",
});
